import createStyledComponent from '../models/StyledComponent';
import domElements from '../utils/domElements';
import constructWithOptions from './constructWithOptions';
var baseStyled = function (tag) {
    return constructWithOptions(createStyledComponent, tag);
};
var styled = baseStyled;
// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
    // @ts-expect-error some react typing bs
    styled[domElement] = baseStyled(domElement);
});
export default styled;
//# sourceMappingURL=styled.js.map